export function readStorage(key: string, fallback = ""): string {
  try {
    return window.localStorage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
}

export function writeStorage(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Storage can fail in private browsing or quota-constrained contexts.
  }
}

export function removeStorage(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // Ignore storage failures.
  }
}

export function readJSON<T>(key: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeJSON<T>(key: string, value: T): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Ignore storage failures.
  }
}

export function readCache<T>(key: string, ttlMs: number): T | null {
  const cached = readJSON<{ value: T; savedAt: number } | null>(key, null);
  if (!cached || typeof cached.savedAt !== "number") return null;
  if (Date.now() - cached.savedAt > ttlMs) return null;
  return cached.value;
}

export function writeCache<T>(key: string, value: T): void {
  writeJSON(key, { value, savedAt: Date.now() });
}
